export const normalizeSeasonNumber = (seasonNumber) => {
  const parsed =
    typeof seasonNumber === "number"
      ? seasonNumber
      : typeof seasonNumber === "string" && seasonNumber.trim()
        ? Number(seasonNumber)
        : null;

  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
};

// A season 1 is a new series, except an announced part ("Part 2"): its
// series has already started, so it counts as returning.
export const isNewSeries = (show) =>
  normalizeSeasonNumber(show?.seasonNumber ?? show?.season) === 1 && !show?.seasonPart;

export const resolveShowId = (show) => {
  if (!show || typeof show !== "object") {
    return null;
  }

  const id = show.id
    ?? show.tvdbId
    ?? show.tvdb_id
    ?? show.imdbId
    ?? show.imdb_id
    ?? show.omdbData?.imdbId
    ?? show.omdbData?.imdbID
    ?? null;

  return id === null || id === undefined || id === "" ? null : String(id);
};

export const normalizeContentRating = (rating) => {
  if (typeof rating !== "string") {
    return null;
  }

  const normalized = rating.trim();
  if (!normalized) {
    return null;
  }

  const compoundNegativeMatch = normalized.match(/^-(\d{1,2}[A-Za-z+]*)$/);
  if (compoundNegativeMatch) {
    const [, normalizedBody] = compoundNegativeMatch;
    return /^\d{1,2}$/.test(normalizedBody)
      ? `${normalizedBody}+`
      : normalizedBody;
  }

  return normalized;
};

const resolveRawContentRating = (release) => {
  if (!release) return null;

  const rating =
    release.contentRating
    ?? release.content_rating
    ?? release.contentRatings
    ?? release.content_ratings;

  if (!rating) return null;

  if (Array.isArray(rating)) {
    const first = rating[0];
    if (!first) return null;
    if (typeof first === "string") return first;
    return first.name || first.rating || first.code || null;
  }

  if (typeof rating === "string") return rating;
  if (typeof rating === "object") {
    return rating.name || rating.rating || rating.code || null;
  }

  return null;
};

export const getContentRating = (release) => normalizeContentRating(resolveRawContentRating(release));
